import { api, endpoints } from '@/api'
import { CryptoHistoryPriceDTO, CryptoHistoryPriceParams } from './historyTypes'

async function fetchCryptoPriceHistory({
  blockchain,
  period,
}: CryptoHistoryPriceParams): Promise<{ data: CryptoHistoryPriceDTO[] }> {
  const response = await api.get(
    endpoints.history.cryptoHistoryPrice(blockchain, period),
  )
  return response.data
}

export const historyApi = {
  fetchCryptoPriceHistory,
}
